<template>
  <v-card class="no-border main-card fill-height">
    <v-card-text>
      <div>
        <div class="text-xs-right">
          <v-btn
            v-if="show_edit_form === false"
            :disabled="
              paymentsForUserWithToken ? !user.invite_token : !user.invite
            "
            @click="show_edit_form = true"
          >
            Edit
          </v-btn>
        </div>
        <div
          v-if="!show_edit_form"
          style="border: 1px solid rgb(230, 239, 255); border-radius: 10px; padding: 16px; margin-bottom: 8px;"
        >
          <h3 class="pb-3">Your payout addresses</h3>
          <p>
            <span class="deposit-address-title">ETH (Ethereum blockchain):</span>
            <span class="deposit-address">{{
              paymentsForUserWithToken ?
              ( user.invite_token ? user.invite_token.eth_addr_hex : "")
                : (user.invite ? user.invite.eth_addr_hex : "")
            }}</span>
          </p>
          <p>
            <span class="deposit-address-title">BNB (Binance Smart Chain):</span>
            <span class="deposit-address">{{
              paymentsForUserWithToken ?
                (user.invite_token ? user.invite_token.bnb_addr_hex : "")
                  :
                    (user.invite ? user.invite.bnb_addr_hex : "")
            }}</span>
          </p>
          <p v-if="paymentsForUserWithToken ? !user.invite_token : !user.invite" class="no-invite">
            You can add payout addresses once you have generated an API key
          </p>
        </div>
        <div v-else>
          <v-layout row wrap>
            <v-flex class="xs12 md12 lg12">
              <v-card
                class="thin-border pa-4"
                style="padding-bottom: 8px !important;"
              >
                <h3 class="confirm-title">Change payout addresses</h3>
                <v-text-field
                  v-model="api_form.eth_addr_hex"
                  label="ETH address"
                  name="eth_address"
                  autocomplete="off"
                  :error-messages="formErrors.eth_addr_hex"
                ></v-text-field>
                <v-text-field
                  v-model="api_form.bnb_addr_hex"
                  label="BNB address"
                  name="bnb_address"
                  value="BNB address"
                  autocomplete="off"
                  :error-messages="formErrors.bnb_addr_hex"
                ></v-text-field>

                <div class="text-xs-right">
                  <v-btn
                    class="mx-0 my-3 common-btn"
                    @click="editPayoutAddresses"
                    >Save</v-btn
                  >
                  <v-btn
                    class="mx-0 my-3 btn-cancel"
                    style="color: #103a84 !important"
                    @click="show_edit_form = false"
                    >Cancel</v-btn
                  >
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div class="mt-4">
        <h3>Payout history</h3>
        <v-data-table
          :headers="tableHeaders"
          :items="payments"
          must-sort
          :rows-per-page-items="[10, 25, 50]"
          :pagination.sync="pagination"
          item-key="id"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable text-xs-left',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                :aria-sort="pagination.descending ? 'descending' : 'ascending'"
                @click="changeSort(header)"
              >
                {{ header.text }}
                <v-icon small>arrow_upward</v-icon>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr v-if="isMobile" @click="props.expanded = !props.expanded">
              <td class="pb-3 pt-2 pl-0 pr-0">
                <v-layout row wrap>
                  <v-flex md12 xs12>
                    <v-layout row wrap>
                      <v-flex xs12 lg12 md12>
                        <strong>
                          {{
                            props.item.ts_utc | formatDate("DD MMM YYYY HH:mm")
                          }}
                        </strong>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6 lg6 md6>
                        Currency
                      </v-flex>
                      <v-flex xs6 lg6 md6>
                        {{ props.item.currency_name }}
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6 lg6 md6>
                        Value
                      </v-flex>
                      <v-flex xs6 lg6 md6>
                        {{
                          $options.filters.toETHFormat(
                            props.item.value_wei_str
                          ) | roundMarketsFractionalAccountValue
                        }}
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
            <tr v-else @click="props.expanded = !props.expanded">
              <td>
                {{ props.item.ts_utc | formatDate("DD MMM YYYY HH:mm") }}
              </td>
              <td>
                {{ props.item.currency_name }}
              </td>
              <td>
                {{
                  $options.filters.toETHFormat(props.item.value_wei_str)
                    | roundMarketsFractionalAccountValue
                }}
              </td>
            </tr>
          </template>
          <template v-slot:expand="props">
            <v-card flat class="expand-card">
              <v-card-text>
                Transaction ID: {{ props.item.tx_id }}
              </v-card-text>
              <v-card-text> To address: {{ props.item.to_addr }} </v-card-text>
              <v-card-text>
                Value (WEI): {{ props.item.value_wei_str }} ({{
                  $options.filters.toETHFormat(props.item.value_wei_str)
                    | roundMarketsFractionalAccountValue
                }}
                {{ props.item.currency_name }})
              </v-card-text>
              <v-btn dark color="primary" @click="expandUserDeposits">
                {{ btnTitle }}
              </v-btn>
              <UserDeposits
                v-if="showUserDeposits"
                :key="props.item.id"
                :payment-id="props.item.id"
                :payment-currency="props.item.currency_name"
                :payments-for-user-with-token="paymentsForUserWithToken"
              ></UserDeposits>
            </v-card>
          </template>
        </v-data-table>
      </div>
      <div>
        <h3>Note</h3>
        <ul>
          <li>Payouts are considered on a daily basis</li>
          <li>Your share from ETH deposit is paid out in ETH</li>
          <li>Your share from BNB deposit is paid out in BNB</li>
          <li>The minimum payout value will be no less than 100 USD worth</li>
          <li>The blockchain fee must not exceed 5% of the payout value</li>
          <li>The blockchain fee will be split 50/50 between you and GSMG</li>
        </ul>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.no-invite {
  color: #db4a36 !important;
  caret-color: #db4a36 !important;
  font-size: 12px !important;
  margin-bottom: 0px;
}
.theme--light p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #103a84;
}
.theme--light h3 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  color: #103a84;
}
.theme--light ul li {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #103a84;
}
>>> .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff !important;
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
>>> .btn-cancel {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84 !important;
  background: #e6efff !important;
  border-radius: 30px;
  width: 147px;
  margin: 12px 6px 8px;
  box-shadow: none !important;
}
>>> .theme--light .v-card__text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
}
>>> .theme--light .expand-card {
  border: 1px solid #d1e2ff;
  border-radius: 10px;
  box-sizing: border-box;
  margin-top: 16px;
  margin-bottom: 16px;
  word-break: break-all;
}
.theme--light .thin-border {
  border: 1px solid #e6efff;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
}
.theme--light .switch >>> .v-label {
  color: #103a84;
}
.theme--light >>> .v-label {
  color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
>>> .theme--light .v-input__slot::before {
  border-color: #b8d2ff !important;
}
.theme--light .main-card {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--light .deposit-address-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #7395d0;
}
.theme--light .deposit-address {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: rgba(70, 138, 255, 1);
  word-wrap: break-word;
  margin-bottom: 0px !important;
}
>>> .v-datatable__actions__range-controls .v-btn {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  height: 36px;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  margin: 6px 8px;
  min-width: 88px;
  outline: 0;
  text-transform: uppercase;
  text-decoration: none;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  position: relative;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: transparent;
  max-width: 0;
}
>>> .theme--light.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7395d0;
}
>>> .theme--light.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}

>>> .theme--light.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #103a84;
}
>>> .theme--light.v-datatable thead th.column.sortable.active,
>>> .theme--light.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--light.v-datatable thead th.column.sortable:hover {
  color: #103a84;
}
>>> .theme--light .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #7395d0;
}
>>> .theme--light .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84 !important;
  max-height: 24px;
}

>>> .theme--light
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  padding-left: 8px;
}

>>> .theme--light .v-datatable__actions .v-input__slot {
  border: 0.8px solid #103a84;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}

>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::after,
>>> .v-datatable__actions
  .v-text-field
  > .v-input__control
  > .v-input__slot::before {
  width: 0px;
}
>>> .theme--light .v-datatable__actions .v-btn {
  color: #103a84;
}
>>> .v-datatable__actions .theme--light.v-icon {
  color: #103a84 !important;
}
>>> .v-datatable__actions .v-input__append-inner {
  margin-top: 0px !important;
}
>>> .theme--light.v-btn.v-btn--disabled,
>>> .theme--light.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--light.v-btn.v-btn--disabled .v-icon {
  color: #b8d2ff !important;
}
>>> .theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--light.v-table tbody tr:not(:first-child) {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__actions {
  border-top: 1px solid #e6efff;
}

>>> .theme--light.v-datatable .v-datatable__expand-col--expanded {
  border-bottom: 1px solid #e6efff;
}
>>> .theme--dark.v-table {
  background: #212121;
}
>>> .theme--dark.v-datatable .v-datatable__actions {
  background: #212121;
}
>>> .theme--dark.v-datatable thead th {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark.v-datatable tbody tr td {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #e9e9e9;
}
>>> .theme--dark.v-datatable tbody tr td .v-btn {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
>>> .theme--dark.v-datatable thead th.column.sortable.active,
>>> .theme--dark.v-datatable thead th.column.sortable.active .v-icon,
>>> .theme--dark.v-datatable thead th.column.sortable:hover {
  color: #ffffff;
}
>>> .theme--dark .v-datatable__actions {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-datatable__actions .v-select__selections {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  max-height: 24px;
  color: rgba(235, 235, 245, 0.6);
}

>>> .theme--dark
  .v-datatable__actions
  .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  padding-left: 8px;
  color: #ffffff;
}

>>> .theme--dark .v-datatable__actions .v-input__slot {
  border: 0.8px solid #ffffff;
  box-sizing: border-box;
  border-radius: 5px;
  max-height: 24px;
}
>>> .v-datatable__actions .theme--dark.v-icon {
  color: #ffffff !important;
}
>>> .theme--dark.v-btn.v-btn--disabled,
>>> .theme--dark.v-btn.v-btn--disabled .v-btn__loading,
>>> .theme--dark.v-btn.v-btn--disabled .v-icon {
  color: rgba(235, 235, 245, 0.6) !important;
}
.theme--dark .main-card {
  background: #212121;
  box-shadow: none;
  border-radius: 0px 15px 15px 15px;
  padding-top: 15px;
  padding-bottom: 15px;
}
.theme--dark .thin-border {
  border: 1px solid #9e9e9e;
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: none !important;
  background: #212121;
}
.theme--dark .deposit-address-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .deposit-address {
  font-family: "Lato", serif !important;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #e9e9e9;
  word-wrap: break-word;
  margin-bottom: 0px !important;
}
.theme--dark h3 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  color: #ffffff;
}
.theme--dark ul li {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  color: #ffffff;
}
>>> .theme--dark .v-card__text {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
}
>>> .theme--dark .expand-card {
  background: #212121 !important;
  border: 1px solid #454547;
  border-radius: 10px;
  box-sizing: border-box;
  margin-top: 16px;
  margin-bottom: 16px;
  word-break: break-all;
}
.theme--dark p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #ffffff;
}
</style>

<script>
import swal from "sweetalert2";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import UserDeposits from "./UserDeposits";

export default {
  components: {
    UserDeposits
  },
  props: ["paymentsForUserWithToken"],
  data() {
    return {
      pagination: {
        descending: true,
        sortBy: "ts_utc_secs",
        rowsPerPage: 10
      },
      formErrors: {},
      show_edit_form: false,
      windowWidth: window.innerWidth,
      showUserDeposits: false,
      btnTitle: "Show deposits",
      payments_token: []
    };
  },
  created: async function() {
    if (this.paymentsForUserWithToken) {
      await axios.get("/api/v1/partners/payments").then(res => {
        this.payments_token = res.data;
      });
    } else {
      await this.$store.dispatch("whitelabel/fetchPayments");
    }
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode",
      user: "auth/user",
      payments_api: "whitelabel/payments"
    }),
    payments() {
      if (this.paymentsForUserWithToken) {
        return this.payments_token;
      } else {
        return this.payments_api;
      }
    },
    api_form() {
      if (this.paymentsForUserWithToken) {
        if (this.user.invite_token) {
          return {
            eth_addr_hex: this.user.invite_token.eth_addr_hex
                    ? this.user.invite_token.eth_addr_hex
                    : "",
            bnb_addr_hex: this.user.invite_token.bnb_addr_hex
                    ? this.user.invite_token.bnb_addr_hex
                    : ""
          };
        }
      } else {
        if (this.user.invite) {
          return {
            eth_addr_hex: this.user.invite.eth_addr_hex
                    ? this.user.invite.eth_addr_hex
                    : "",
            bnb_addr_hex: this.user.invite.bnb_addr_hex
                    ? this.user.invite.bnb_addr_hex
                    : ""
          };
        }
      }

      return {
        eth_addr_hex: "",
        bnb_addr_hex: ""
      };
    },
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    isMobile() {
      return this.windowWidth < 768;
    },
    tableHeaders() {
      if (this.isMobile) {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc_secs"
          }
        ];
      } else {
        return [
          {
            text: `Date (${moment()
              .tz(moment.tz.guess())
              .format("z")})`,
            value: "ts_utc"
          },
          { text: "Currency", value: "currency_name" },
          { text: "Value", value: "value_wei_str" }
        ];
      }
    }
  },
  methods: {
    expandUserDeposits: function() {
      this.showUserDeposits = !this.showUserDeposits;
      this.btnTitle = this.showUserDeposits ? "Hide deposits" : "Show deposits";
    },
    editPayoutAddresses: async function() {
      try {
        let url = "/api/v1/whitelabel/change-payouts-addresses";
        if (this.paymentsForUserWithToken) {
          url = "/api/v1/partners/change-payouts-addresses";
        }
        await axios
          .post(url, {
            eth_addr_hex: this.api_form.eth_addr_hex,
            bnb_addr_hex: this.api_form.bnb_addr_hex
          })
          .then(async response => {
            if (response.status === 200) {
              if (response.data.status === true) {
                await swal({
                  title: "Payout addresses",
                  text: "Payout addresses updated successfully",
                  showCloseButton: true,
                  imageUrl: "/img/popup_img_success.png",
                  customClass: this.themeDark
                    ? "swal-type-success-dark"
                    : "swal-type-success",
                  imageHeight: 80,
                  imageWidth: 80
                });

                this.show_edit_form = false;
                this.formErrors = {};
                this.api_form.eth_addr_hex = "";
                this.api_form.bnb_addr_hex = "";
                await this.$store.dispatch("auth/fetchUser");
              } else {
                await this.errorAlert(
                  "Problem update adddresses",
                  "Please try again later."
                );
              }
            }
          })
          .catch(async error => {
            if (error.response.status === 422) {
              this.formErrors = error.response.data.errors;
            } else {
              await this.errorAlert(
                "Problem update adddresses",
                "Please try again later."
              );
            }
          });
      } catch (error) {
        await this.errorAlert(
          "Problem update adddresses",
          "Please try again later."
        );
      }
    },
    async errorAlert(title, description) {
      await swal({
        title: title,
        html: description,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark
          ? "swal-type-error-dark"
          : "swal-type-error",
        imageUrl: "/img/popup_img_error.png",
        imageHeight: 80,
        imageWidth: 80
      });
    },
    changeSort: function(header) {
      this.pagination.sortBy = header.value;
      this.pagination.descending = !this.pagination.descending;
    },
    customTableSort(items, index, isDescending) {
      const factor = isDescending ? -1 : 1;

      items.sort((a, b) => {
        const aValue = a[index];
        const bValue = b[index];

        if (aValue === bValue) {
          return 0;
        }

        return factor * (aValue < bValue ? -1 : 1);
      });

      return items;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/whitelabel/Payouts.vue